if (typeof jQuery !== 'undefined') {
  $(function(){

    let hash = window.location.hash;
    if(hash == '#enquiry-form') {
      $('.cta-block').hide();
      $('.enquiry-form').show();
    }
    if(hash == '#support-form') {
      $('.cta-block').hide();
      $('.support-form').show();
    }

    $('.trigger-enquiry-form').on('click',function(){
      $('.cta-block').slideUp(400);
      $('.enquiry-form').slideDown(400);
    });

    $('.trigger-support-form').on('click',function(){
      $('.cta-block').slideUp(400);
      $('.support-form').slideDown(400);
    });

    $('.trigger-contact-form-options').on('click',function(){
      $('.cta-block').slideDown(400);
      $('.form').slideUp(400);
    });

  });
}